import React from "react";
import { MathJax, MathJaxContext } from "better-react-mathjax";

const RenderMathQuestion = ({ question }) => {
  const config = { loader: { load: ["[tex]/html"] } };

  // Clean HTML tags and keep only meaningful content
  const cleanedHtml = question
    .replace(/<head.*?>.*?<\/head>/gis, "")
    .replace(/<html.*?>/gis, "")
    .replace(/<\/html>/gis, "")
    .replace(/<body.*?>/gis, "")
    .replace(/<\/body>/gis, "")
    .replace(/<p.*?>/gis, "")
    .replace(/<\/p>/gis, "")
    .trim(); // remove leading/trailing spaces

  return (
    <MathJaxContext config={config}>
      <MathJax dynamic>
        <div dangerouslySetInnerHTML={{ __html: cleanedHtml }} />
      </MathJax>
    </MathJaxContext>
  );
};

export default RenderMathQuestion;
